import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    hbspt: any;
  }
}
export function ApplicationForm() {
  useEffect(() => {
    // Load HubSpot form script
    const script = document.createElement('script');
    script.src = 'https://js-na2.hsforms.net/forms/embed/v2.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    script.onload = () => {
      // Create HubSpot form once script is loaded
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'na2',
          portalId: '244724304',
          formId: '9b3cb192-f078-4e28-a222-94d65837ef66',
          target: '#hubspot-form-container'
        });
      }
    };
    return () => {
      // Cleanup script on unmount
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-white flex flex-col font-sans" data-id="element-558">
      <Navigation data-id="element-559" />

      <main className="flex-grow py-12 px-4 sm:px-6 lg:px-8 mt-20" data-id="element-560">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200" data-id="element-561">
          <div className="bg-gray-50 border-b border-gray-200 p-8 text-center" data-id="element-562">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-563">
              Business Funding Application
            </h1>
            <p className="text-gray-600" data-id="element-564">
              Complete this form to get funding options within 24-48 hours
            </p>
          </div>

          <div className="p-8" data-id="element-565">
            <div id="hubspot-form-container" data-id="element-566"></div>
          </div>
        </div>
      </main>

      <Footer data-id="element-567" />
    </div>;
}